// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const ProfileTeacherApi = createApi({
  reducerPath: "ProfileTeacherApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
  }),
  tagTypes: ["avis"],
  endpoints: (builder) => ({
    getProfileTeacher: builder.query<any, any>({
      query: (params) =>
        `/avis/user/getProfile?profId=${params.profId}&studId=${params.studId}`,
      providesTags: ["avis"],
    }),
    getListFollowTeacher: builder.query<any, any>({
      query: (params) =>
        `/avis/follow/list?profId=${params.profId}&studId=${params.studId}`,
    }),
    sendAvis: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/avis`,
          method: "post",
          body,
        };
      },
      invalidatesTags: ["avis"],
    }),
    follow: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/avis/follow`,
          method: "post",
          body,
        };
      },
      invalidatesTags: ["avis"],
    }),
    unFollow: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/avis/unfollow`,
          method: "post",
          body,
        };
      },
      invalidatesTags: ["avis"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetProfileTeacherQuery,
  useSendAvisMutation,
  useFollowMutation,
  useUnFollowMutation,
} = ProfileTeacherApi;
